import { render } from "./App.vue?vue&type=template&id=cccd5cce"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cccd5cce&lang=css"
script.render = render

export default script